module.exports = __webpack_public_path__ + "static/media/no-record-data.5509ec7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/no-record-data.png
// module id = 328
// module chunks = 6